import { api } from "./apiClient";

export const submittalsAPI = {
  listByProject: (projectId) => api.get(`/projects/${projectId}/submittals`),

  create: (projectId, payload) =>
    api.post(`/projects/${projectId}/submittals`, payload),

  review: (projectId, submittalId, payload) =>
    api.post(
      `/projects/${projectId}/submittals/${submittalId}/reviews`,
      payload,
    ),

  listAttachments: (projectId, submittalId) =>
    api.get(`/projects/${projectId}/submittals/${submittalId}/attachments`),

  uploadDocument: (projectId, submittalId, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(
      `/projects/${projectId}/submittals/${submittalId}/attachments/documents`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  },

  uploadPhoto: (projectId, submittalId, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(
      `/projects/${projectId}/submittals/${submittalId}/attachments/photos`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  },

  deleteAttachment: (projectId, submittalId, attachmentId) =>
    api.delete(
      `/projects/${projectId}/submittals/${submittalId}/attachments/${attachmentId}`,
    ),

  sendInternal: (projectId, formData) =>
    api.post(`/projects/${projectId}/internal-submittals/email`, formData, {
      timeout: 120000,
      headers: { "Content-Type": "multipart/form-data" },
    }),
};
